export default {
  coupon: {
    selectCoupons: 'Select Coupons',
    tips: 'Recommended <span class="orange-text">{x} coupon(s)</span> selected, saving <span class="orange-text">{y}</span>',
    couponTips: '<span class="orange-text">{x} coupon(s)</span> selected, saving <span class="orange-text">{y}</span>',
    noSelectedTips: '<span class="orange-text">{x} Coupon(s)</span> Available',
    changeCard: 'Change Payment Card',
    automaticPay: 'Automatic Pay',
    authorized: 'Authorized',
    unauthorized: 'Unauthorized',
  },
  automaticPay: {
    queryRecords: 'Close Query Record',
    actionTime: 'Operation Time',
    actionType: 'Operation Type',
    actionResult: 'Operation Result',
    resultDesc: 'Result Description',
    activate: 'Open',
    approved: 'Approved',
    rejected: 'Rejected',
    underReview: 'Under Review',
    autoDeductClose: 'Do you want to disable automatic payment?',
    confirmSubmitClose: 'Please confirm whether you have submitted an application to disable automatic payment.',
    closeNotice: 'Once the application is approved, the system will no longer automatically deduct payments. If the payment deadline is exceeded, the system will automatically unenroll you from the course.',
    cancelReasonPrompt: 'Please select a cancellation reason:',
    reasonPrompt: 'Select a reason',
    otherReason: 'Others',
    closeReasonInput: 'Please provide a reason for disabling automatic payment.',
    installmentPlan: 'Installment Payment Plan',
    requestSubmitted: 'Your application to disable automatic payment has been submitted.',
    underReviewNotice: 'You have an application under review; please do not submit duplicates.',
    viewReviewResult: ['You can check the review result in ', '.'],
    autoApproved: 'Automatically approved',
    turnOffAutoDebit: 'Do you want to disable automatic payment?',
    paymentInfo: 'Payment Details',
    paymentTime: 'Payment Time',
    paymentStatus: 'Payment Status',
    paymentResult: 'Result Description',
    paymentApproved: 'Success',
    paymentRejected: 'Failed',
  },
}
